import React, {useState} from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from 'react-bootstrap';
import Swal from "sweetalert2";
 

function ModalConfirmarInfoPersonal({cualInfo, datos, idUsuario }) {

    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [mostrarCambio, setMostrarCambio] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    

    async function almacenarInfo(event){
        event.preventDefault();


        try{
            const resCambio = await axios.post("/confirmar-info", {
               params: {cualInfo: cualInfo, datos, idUsuario: idUsuario}
            });

            await Swal.fire({ icon: "success", title: "Éxito", text: resCambio?.data?.mensaje || "Información confirmada correctamente.", customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar', cancelButton: 'mi-boton-cancelar' } });
            window.location.reload();
            return;
        }
        catch(err){
            console.log("error al confirmar información.", err);
            await Swal.fire({ icon: "error", title: "Error al confirmar información", text: "No fue posible confirmar información.", confirmButtonText: "Aceptar" });
        }
    }

    



    return(
    <div>
        <Button className="w-100 mt-3" variant="secondary" onClick={handleShow}>
            <i className="bi bi-save2-fill me-2"></i>
            Confirmar Información {cualInfo === "Personal" ? "Personal" : cualInfo === "Profesional" ? "Profesional" : "Bancaria"}
        </Button>

        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>{cualInfo === "Personal" ? "Confirmar información Personal" : "Confirmar información profesional"}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div>
                    <p className="mb-4 text-muted">
                        Antes de hacer clic en guardar, asegúrate de confirmar que tengas todos los datos guardados correctamente, porque una vez almacenados ya no se podrán modificar.
                    </p>
                    
                    <button onClick={almacenarInfo} className="btn btn-primary w-100">Confirmar información</button>
                </div>
            </Modal.Body>
        </Modal>
    </div>
    )
}



export default ModalConfirmarInfoPersonal;